<template>
  <div style="background: #f0f1f5">
    <HeaderComponent
      :pageContent="pageHeader"
       @change_language="handleHeaderClick"
      ></HeaderComponent>     <br /><br />
    <div class="container py-4">
      <div class="row">
        <div class="col-md-6">
          <h1 style="font-weight: 500">{{pageContent.pageTitle}}</h1>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3524.192964795998!2d-82.48018252397202!3d27.95737601441855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2c380e47f625d%3A0x3c6f5d33f4098a31!2s1730%20W%20Union%20St%2C%20Tampa%2C%20FL%2033607%2C%20USA!5e0!3m2!1sen!2sph!4v1738593277834!5m2!1sen!2sph"
            width="100%"
            height="450"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div class="col-md-5">
          <h4 class="text-primary">{{pageContent.introHeadline}}</h4>
          <br />
          <p>
            {{pageContent.introDescription}}
          </p>
          <br />
          <div class="d-flex flex-row flex-wrap">
            <div class="col-md-4 d-flex flex-column align-items-center mb-1" @click="scrollToSection('cars')" style="cursor:pointer;">
              <img
                src="assets/images/transportation/icons/1.png"
                class="img-fluid d-block"
              /><br />
              <p>            {{pageContent.carRental}}
              </p>
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center mb-1" @click="scrollToSection('public-transit')" style="cursor:pointer;">
              <img
                src="assets/images/transportation/icons/2.png"
                class="img-fluid d-block"
              /><br />
              <p>{{pageContent.publicTransit}}</p>
            </div>
            <div class="col-md-4 d-flex flex-column align-items-center mb-1" @click="scrollToSection('bike-scooters')" style="cursor:pointer;">
              <img
                src="assets/images/transportation/icons/3.png"
                class="img-fluid d-block"
              /><br />
              <p>{{pageContent.bikeScooters}}</p>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row" id="cars">
        <div class="col-md-12">
          <h1>{{pageContent.carRentalSectionTitle}}</h1>
          <hr />
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div class="col-md-4">
                <a
                  href="https://turo.com/us/en/car-rental/united-states/tampa-fl"
                  target="_blank"
                >
                  <img
                    src="assets/images/transportation/1.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <p class="text-center">
                    {{pageContent.turoDescription}}
                  </p>
                </a>
              </div>

              <div class="col-md-4">
                <a
                  href="https://getaround.com/car-rental/tampa-fl"
                  target="_blank"
                >
                  <img
                    src="assets/images/transportation/2.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <p class="text-center">
                    {{pageContent.getaroundDescription}}

                  </p>
                </a>
              </div>

              <div class="col-md-4">
                <a
                  href="http://www.facebook.com/tampacashrentals/"
                  target="_blank"
                >
                  <img
                    src="assets/images/transportation/3.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <p class="text-center">
                    {{pageContent.advanceRentDescription}}

                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="row" id="public-transit">
        <div class="col-md-12">
          <h1>{{pageContent.publicTransit}}</h1>
          <hr />
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div class="col-md-4 justify-content-center">
                <a href="https://www.gohart.org" target="_blank">
                  <img
                    src="assets/images/transportation/4.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <p class="text-center">
                    {{pageContent.hartDescription}}
                  </p>
                </a>
              </div>

              <div class="col-md-4 justify-content-center">
                <a href="http://www.tecolinestreetcar.org" target="_blank">
                  <img
                    src="assets/images/transportation/5.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <p class="text-center">
                    {{pageContent.tecoDescription}}
                  </p>
                </a>
              </div>

              <div class="col-md-4 justify-content-center">
                <a href="https://www.ridedowntowner.com" target="_blank">
                  <img
                    src="assets/images/transportation/6.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <p class="text-center">
                    {{pageContent.downtownerDescription}}
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="row" id="bike-scooters">
        <div class="col-md-12">
          <h1> {{pageContent.bikeScooters}}</h1>
          <hr />
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div class="col-md-6 justify-content-center">
                <a href="http://www.tecolinestreetcar.org" target="_blank">
                  <img
                    src="assets/images/transportation/7.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <h4 class="text-center">{{pageContent.coastBikeShareTitle}}</h4>
                  <div class="px-4">
                    <p class="text-center">
                      {{pageContent.coastBikeShareDescription}}
                    </p>
                  </div>
                </a>
              </div>

              <div class="col-md-6 justify-content-center">
                <a href="https://www.ridedowntowner.com" target="_blank">
                  <img
                    src="assets/images/transportation/8.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto"
                  />
                  <h4 class="text-center"> {{pageContent.escooterTitle}}</h4>
                  <div class="px-4">
                    <p class="text-center">
                      {{pageContent.escooterDescription}}
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br /><br /><br />
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
 
 <script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "AboutUs",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data(){
    return {
      pageContent: [],
      pageHeader:[],
      pageFooter:[],
    }
  }, mounted() {
    const storedLanguage = localStorage.getItem("language");
  if (storedLanguage) {
    this.language = storedLanguage;
  }
  this.convertLanguage();
  },
  methods: {
    goToLink(link) {
      window.open(`https://${link}`, "_blank");
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === 'us') {
        lang = 'en';
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.transportation[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };
      
        this.pageHeader={
          ...this.pageHeader,
          ...pageHeader,
        }
        this.pageFooter={
          ...this.pageFooter,
          ...pageFooter,
        }
        
      }  
    },
  },
};
</script>